// src/components/Order.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaUser, FaEnvelope, FaPhoneAlt, FaRedoAlt } from 'react-icons/fa';

// Helper to generate a random integer between min and max (inclusive)
const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const Order = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);

  // Initialize captcha numbers
  const generateCaptcha = () => {
    setNum1(randomInt(1, 9));
    setNum2(randomInt(1, 9));
    setCaptchaValue('');
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    const solution = num1 + num2;
    if (parseInt(captchaValue, 10) !== solution) {
      alert('Incorrect captcha. Please try again.');
      generateCaptcha();
      return;
    }

    // Collect all form values
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    data.phone = phone;

    // Optionally store in localStorage
    localStorage.setItem('orderInfo', JSON.stringify(data));

    // Redirect to OrderDetails route with state
    navigate('/checkout/order-details', { state: data });
  };

  return (
    <div className="min-h-screen bg-[#02042b] py-16 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <h1 className="text-4xl font-bold text-center text-white mb-2">
          Order Your Assignment
        </h1>
        <p className="text-center text-lg text-gray-300 mb-8">
          Tell us about your assignment details and our experts will get back to you in no time.
        </p>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Form Card */}
          <div className="flex-1 bg-[#fff8ec] border-4 border-yellow-600 rounded-[50px] p-8 shadow-xl">
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Name */}
              <div className="relative">
                <FaUser className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="name"
                  type="text"
                  placeholder="Name"
                  required
                  className="w-full pl-12 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none"
                />
              </div>

              {/* Email */}
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  name="email"
                  type="email"
                  placeholder="Email*"
                  required
                  className="w-full pl-12 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none"
                />
              </div>

              {/* Phone Input */}
            

 <div className="flex gap-4">
                <div className="w-1/2">
                  <PhoneInput
                    country={'in'}
                    value={phone}
                    onChange={setPhone}
                    inputProps={{ name: 'phoneInput', required: true }}
                    containerStyle={{ width: '100%', display: 'flex', alignItems: 'center' }}
                    buttonStyle={{ borderRadius: '0.5rem 0 0 0.5rem' }}
                    inputStyle={{ flex: 1, padding: '0.5rem 0.5rem 0.5rem -2.5rem', borderRadius: '0 0.5rem 0.5rem 0' }}
                    dropdownStyle={{ zIndex: 1000 }}
                  />
                </div>
              </div>

              {/* Captcha */}
              <div className="flex items-center gap-2">
                <div className="flex items-center border border-gray-300 bg-white rounded-lg overflow-hidden">
                  <div className="px-4 font-mono text-lg">
                    {num1} + {num2} =
                  </div>
                  <button
                    type="button"
                    onClick={generateCaptcha}
                    className="px-3 border-l border-gray-300 hover:bg-gray-100"
                  >
                    <FaRedoAlt />
                  </button>
                  <input
                    name="captcha"
                    type="text"
                    placeholder="Captcha*"
                    value={captchaValue}
                    onChange={e => setCaptchaValue(e.target.value)}
                    required
                    className="flex-1 p-2 focus:outline-none"
                  />
                </div>
              </div>

              {/* Terms */}
              <div className="flex items-center text-sm">
                <input id="acceptTerms" name="acceptTerms" type="checkbox" required className="mr-2" />
                <label htmlFor="acceptTerms" className="text-gray-800">
                  I agree with{' '}
                  <Link to="/refund" className="text-yellow-600 underline whitespace-nowrap">
                    Privacy Policy and Terms & Conditions
                  </Link>
                </label>
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full py-3 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-[#02042b] font-semibold shadow-lg hover:from-yellow-500 hover:to-yellow-700 transition-all duration-200"
              >
                Submit
              </button>
            </form>
          </div>

          {/* Features List */}
          <div className="flex-1 space-y-4">
            {[
              { title: 'Quality Work', desc: 'We never compromise on quality.' },
              { title: 'Affordable Pricing', desc: 'We understand student budgets.' },
              { title: 'Plagiarism Free', desc: 'Original, custom-written content.' },
              { title: 'Time-Saving', desc: 'Meet deadlines without stress.' }
            ].map((f, i) => (
              <div
                key={i}
                className="border border-yellow-400 bg-white rounded-lg p-4 text-[#02042b]"
              >
                <h3 className="font-semibold text-lg mb-1">{f.title}</h3>
                <p className="text-sm">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;


















